export { default } from "./TablePaginationActions.mjs";
export { default as tablePaginationActionsClasses } from "./tablePaginationActionsClasses.mjs";